module.exports = "/_next/static/images/chatalt-16a3b166db699add44de0ec1d22f506a.svg";